import React, { lazy } from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carlos Mendoza',
  location: 'Miami',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/male/45.jpg',
  text: 'Finally, someone tells what we lived through in Venezuela. Absolutely excellent.'
}, {
  name: 'Elena Rodríguez',
  location: 'Madrid',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/female/2.jpg',
  text: 'A story that gives you goosebumps. It is the truth that every Venezuelan needs the world to read.'
}, {
  name: 'Ricardo Valero',
  location: 'Bogotá',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/male/22.jpg',
  text: "Incredible analysis. It's a sin not to own this book. Pure history."
}, {
  name: 'Javier López',
  location: 'Political Analyst, Madrid',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/male/7.jpg',
  text: 'I am not Venezuelan, but this book opened my eyes to how powers operate in the shadows. Fascinating and terrifying at the same time.'
}];
export function Testimonials() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 border-t border-gray-900/60" data-id="element-223">
      <div className="max-w-5xl mx-auto" data-id="element-224">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 flex flex-col items-center gap-6" data-id="element-225">
          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-226">
            What Readers Are Saying
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-227">
            Voices that read it
          </h2>

          <div className="h-px w-32" style={{
          background: 'linear-gradient(to right, #DC2626, #2563eb, #d4a85a)'
        }} data-id="element-228" />
        </div>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-229">
          {testimonials.map(t => <div key={t.name} className="bg-[#111] border border-gray-800 rounded-lg p-8 hover:border-[#d4a85a]/30 transition-colors flex flex-col gap-5 text-center md:text-left items-center md:items-start" data-id="element-230">
              {/* 5 gold stars */}
              <div className="flex gap-1" data-id="element-231">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-[#d4a85a] text-[#d4a85a]" data-id="element-232" />)}
              </div>

              {/* Quote */}
              <p className="font-serif italic text-[#e8e2d4] text-lg leading-[1.6] font-light" data-id="element-233">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-4 border-t border-gray-800/60 w-full justify-center md:justify-start" data-id="element-234">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#d4a85a]/60 flex-shrink-0 shadow-[0_0_15px_rgba(212,168,90,0.15)]" data-id="element-235">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" data-id="element-236" />
                </div>
                <div className="text-left" data-id="element-237">
                  <p className="text-[#e8e2d4] text-sm font-semibold" data-id="element-238">
                    {t.name}
                  </p>
                  <p className="text-gray-500 text-xs mt-0.5" data-id="element-239">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}